import {areIntervalsOverlapping, compareAsc} from 'date-fns';

type CollidableDrive = {
  start: Date;
  end: Date;
};

type LaneAssignment = {
  lane: number;
  laneCount: number;
};

export const getRowCollisionLayout = <TDrive extends CollidableDrive>(
  drives: TDrive[]
): Array<TDrive & LaneAssignment> => {
  const lanes: TDrive[][] = [];

  const laneByDrive = new Map<TDrive, number>();

  [...drives]
    .sort((driveA, driveB) => compareAsc(driveA.start, driveB.start))
    .forEach((drive) => {
      const freeLaneIndex = lanes.findIndex(
        (lane) =>
          !lane.some((placed) =>
            areIntervalsOverlapping(
              {start: drive.start, end: drive.end},
              {start: placed.start, end: placed.end}
            )
          )
      );

      if (freeLaneIndex === -1) {
        lanes.push([drive]);
        laneByDrive.set(drive, lanes.length - 1);
        return;
      }

      lanes[freeLaneIndex].push(drive);
      laneByDrive.set(drive, freeLaneIndex);
    });
  return drives.map((drive) => ({
    ...drive,
    lane: laneByDrive.get(drive) ?? 0,
    laneCount: lanes.length,
  }));
};
